import productListService from '../../services/productListService'

class ProductListController {
  fetchProductList = productListService.fetchProductList
  fetchProductLists = productListService.fetchProductLists
  createProductList = productListService.createProductList
  updateProductList = productListService.updateProductList
  putProductList = productListService.putProductList
  deleteProductList = productListService.deleteProductList
}

export default new ProductListController()
 


// WEBPACK FOOTER //
// ../src/controllers/productListController/productsListController.js